import React, {memo} from 'react';
import {useParams} from 'react-router-dom';

import {useAdminAccessRight} from 'src/hooks/access-rights';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Group} from '@pb/kit-component-group';


import {useUntrackedEvents} from '../hooks';

export const ExcludeAccount = memo<Record<never, void>>(function ExcludeAccount() {
    const params = useParams<{accountId: string}>();
    const accountId = params.accountId ? +params.accountId : -1;

    const {events, setEvents} = useUntrackedEvents();
    const {canEditApiV2} = useAdminAccessRight();

    const onCheckBoxClick = () => {
        setEvents(!events);
    };

    return (
        <Group direction="v" gap="s" alignItems="start">
            <CheckBox
                label="Exclude account from the usage data"
                checked={events}
                onCheckBoxChange={onCheckBoxClick}
                disabled={!canEditApiV2(accountId)}
            />
            <div>
                Note: Should be set only for test accounts
            </div>
        </Group>
    );
});
